import axios from 'axios'
import baseService from './baseService'
import config from './config'

// iPad hand-off links, see DocumentSigningLinkController. info, document, disclosure, consent and sign are anonymous: the token is the authority.
const documentSigningLinkService = {
  create (signingLinkRequestModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .post('/documentSigningLink/create', signingLinkRequestModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getInfo (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .get('/documentSigningLink/info', { params: { token: token } })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  },
  acceptDisclosure (consentModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .post('/documentSigningLink/consent', consentModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  },
  verify (envelopeId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .get('/documentSigningLink/verify', { params: { envelopeId: envelopeId } })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  },
  signByToken (tokenSignatureModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .post('/documentSigningLink/sign', tokenSignatureModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  },
  // through the link's token, not an open document url, so only the linked document can be read
  documentUrl (token) {
    return config.apiUrl + 'documentSigningLink/document?token=' + encodeURIComponent(token)
  },
  // the Electronic Record and Signature Disclosure the signer agrees to before signing
  disclosureUrl (token) {
    return config.apiUrl + 'documentSigningLink/disclosure?token=' + encodeURIComponent(token)
  },
  // the token comes back url-encoded, ready to go into the query string
  signingUrl (token) {
    return window.location.origin + '/sign/document?token=' + token
  }
}

export default documentSigningLinkService
